/* ============================================================
   YURI · 유리 — theme.js
   No dependencies. Defensive: every module bails out quietly
   if its markup isn't on the page.
   ============================================================ */
(function () {
  'use strict';

  var T = window.kbTheme || {};
  var routes = T.routes || {};
  var strings = T.strings || {};

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ── toast ─────────────────────────────────────────── */
  var toastTimer;
  function toast(msg, isError) {
    var t = $('#kb-toast');
    if (!t) return;
    t.querySelector('.kb-toast__msg').textContent = msg;
    t.classList.toggle('kb-toast--err', !!isError);
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* ── scrim / overlays ──────────────────────────────── */
  var scrim = $('#kb-scrim');
  var openPanels = [];

  function lockScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }
  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    if (scrim) scrim.classList.add('is-on');
    lockScroll(true);
    if (openPanels.indexOf(el) === -1) openPanels.push(el);
  }
  function closePanels() {
    openPanels.forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    openPanels = [];
    if (scrim) scrim.classList.remove('is-on');
    lockScroll(false);
  }
  on(scrim, 'click', closePanels);
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') closePanels();
  });

  /* ── header ────────────────────────────────────────── */
  var header = $('#kb-header');
  if (header) {
    var stuck = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    stuck();
    window.addEventListener('scroll', stuck, { passive: true });
  }

  on($('#kb-burger'), 'click', function () { openPanel($('#kb-navdrawer')); });
  on($('#kb-nav-close'), 'click', closePanels);

  var searchBar = $('#kb-searchbar');
  on($('#kb-search-toggle'), 'click', function () {
    if (!searchBar) return;
    var open = searchBar.classList.toggle('is-open');
    if (open) { var i = $('input[type="search"]', searchBar); if (i) i.focus(); }
  });

  /* ── announcement rotator ──────────────────────────── */
  var slides = $$('.kb-announce__slide');
  if (slides.length > 1) {
    var si = 0;
    setInterval(function () {
      slides[si].classList.remove('is-on');
      si = (si + 1) % slides.length;
      slides[si].classList.add('is-on');
    }, 4500);
  }

  /* ── cart ──────────────────────────────────────────── */
  var drawer = $('#kb-cart-drawer');

  function setCount(n) {
    $$('.kb-badge').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('is-on', n > 0);
    });
  }

  function refreshCartUI(openIt) {
    var url = (routes.root_url === '/' ? '' : routes.root_url) + '/?sections=cart-drawer';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var host = $('#shopify-section-cart-drawer');
        var html = data['cart-drawer'];
        if (host && html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#shopify-section-cart-drawer') || tmp.firstElementChild;
          if (fresh) host.innerHTML = fresh.innerHTML;
        }
        drawer = $('#kb-cart-drawer');
        return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (openIt) openPanel(drawer);
      })
      .catch(function () { /* keep the page usable no matter what */ });
  }

  function cartError(res) {
    return res.json().then(function (d) {
      throw new Error(d.description || d.message || strings.error || 'Κάτι πήγε στραβά.');
    });
  }

  function addToCart(payload, btn) {
    var label;
    if (btn) { label = btn.innerHTML; btn.disabled = true; btn.innerHTML = strings.adding || 'Προσθήκη…'; }
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.ok ? res.json() : cartError(res); })
      .then(function () { return refreshCartUI(true); })
      .catch(function (err) { toast(err.message, true); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
      });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.ok ? res.json() : cartError(res); })
      .then(function () {
        if ($('#kb-cart-page')) { window.location.reload(); return; }
        return refreshCartUI(false);
      })
      .catch(function (err) { toast(err.message, true); });
  }

  /* delegated cart events — survives drawer re-rendering */
  on(document, 'click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) {
      e.preventDefault();
      openPanel($('#kb-cart-drawer'));
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closePanels(); return; }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.kb-qty');
      var input = $('input', wrap);
      if (!input) return;
      var next = Math.max(parseInt(input.min || 0, 10), (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(parseInt(rm.dataset.lineRemove, 10), 0);
      return;
    }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart({ items: [{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }] }, quick);
    }
  });

  on(document, 'change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    changeLine(parseInt(input.dataset.lineQty, 10), q);
  });

  /* product form submit → ajax */
  on(document, 'submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var payload = { items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || 1, 10) }] };
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m && v) props[m[1]] = v;
    });
    if (Object.keys(props).length) payload.items[0].properties = props;
    if (!payload.items[0].id) { toast(strings.select_option || 'Διάλεξε παραλλαγή.', true); return; }
    addToCart(payload, form.querySelector('[data-atc]'));
  });

  /* ── free-shipping bar ─────────────────────────────── */
  function shipBar() {
    $$('[data-ship-bar]').forEach(function (bar) {
      var pct = parseFloat(bar.dataset.shipBar) || 0;
      requestAnimationFrame(function () {
        var fill = $('.kb-ship-bar__fill', bar);
        if (fill) fill.style.width = Math.min(100, pct) + '%';
      });
    });
  }
  shipBar();
  new MutationObserver(shipBar).observe(document.body, { childList: true, subtree: true });

  /* ── variant picker ────────────────────────────────── */
  $$('[data-variant-picker]').forEach(function (root) {
    var dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = $('[data-variant-id]', root);
    var priceBox = $('[data-price-box]', root);
    var atc = $('[data-atc]', root);
    var stock = $('[data-stock]', root);
    var sku = $('[data-sku]', root);

    function selected() {
      return $$('[data-opt]:checked', root).map(function (i) { return i.value; });
    }
    function match(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function markUnavailable(opts) {
      $$('[data-opt]', root).forEach(function (input) {
        var pos = parseInt(input.dataset.opt, 10);
        var test = opts.slice();
        test[pos] = input.value;
        var exists = variants.some(function (v) {
          return v.options.every(function (o, i) {
            return i === pos ? o === input.value : o === test[i];
          }) && v.available;
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-gone', !exists);
      });
    }
    function update() {
      var opts = selected();
      var v = match(opts);
      markUnavailable(opts);

      $$('[data-opt-current]', root).forEach(function (el) {
        el.textContent = opts[parseInt(el.dataset.optCurrent, 10)] || '';
      });

      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = strings.unavailable || 'Μη διαθέσιμο'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceBox && v.price_html) priceBox.innerHTML = v.price_html;
      if (sku) sku.textContent = v.sku || '';
      if (atc) {
        atc.disabled = !v.available;
        atc.innerHTML = v.available ? (strings.add_to_cart || 'Στο καλάθι') : (strings.sold_out || 'Εξαντλήθηκε');
      }
      if (stock) {
        stock.className = 'kb-stock ' + (!v.available ? 'kb-stock--out' : (v.low ? 'kb-stock--low' : ''));
        stock.innerHTML = '<span class="kb-stock__dot"></span><span>' + (v.stock_label || '') + '</span>';
      }
      if (v.image_id) {
        var thumb = $('.kb-thumb[data-media-id="' + v.image_id + '"]', document);
        if (thumb) thumb.click();
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* older browsers: skip */ }
    }

    $$('[data-opt]', root).forEach(function (i) { on(i, 'change', update); });
    update();
  });

  /* ── gallery ───────────────────────────────────────── */
  (function gallery() {
    var main = $('#kb-gallery-main');
    if (!main) return;
    $$('.kb-thumb').forEach(function (t) {
      on(t, 'click', function () {
        $$('.kb-thumb').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-selected', 'false'); });
        t.classList.add('is-on');
        t.setAttribute('aria-selected', 'true');
        main.style.opacity = '0.35';
        var img = new Image();
        img.onload = function () {
          main.src = t.dataset.full;
          main.srcset = '';
          main.alt = t.dataset.alt || '';
          main.style.opacity = '1';
        };
        img.src = t.dataset.full;
      });
    });
  })();

  /* ── facets: auto-submit ───────────────────────────── */
  $$('[data-facet-form]').forEach(function (form) {
    on(form, 'change', function () { form.submit(); });
  });

  /* ── product recommendations ───────────────────────── */
  $$('[data-recs]').forEach(function (el) {
    var url = el.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recs]');
        if (!fresh) return;
        el.innerHTML = fresh.innerHTML;
        $$('[data-reveal]', el).forEach(function (n) { n.classList.add('kb-reveal', 'is-in'); });
      })
      .catch(function () {});
  });

  /* ── scroll reveal + rail ──────────────────────────── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    $$('[data-reveal]').forEach(function (el, i) {
      el.classList.add('kb-reveal');
      el.style.transitionDelay = (Math.min(i % 4, 3) * 90) + 'ms';
      io.observe(el);
    });
    $$('[data-rail]').forEach(function (el) { io.observe(el); });

    /* counting stats */
    var countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        countIO.unobserve(el);
        var target = parseFloat(el.dataset.count);
        if (isNaN(target)) return;
        var suffix = el.dataset.suffix || '';
        var decimals = (String(el.dataset.count).split('.')[1] || '').length;
        var start = performance.now(), dur = 1400;
        (function step(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
        })(start);
      });
    }, { threshold: 0.6 });
    $$('[data-count]').forEach(function (el) { countIO.observe(el); });
  } else {
    $$('[data-reveal],[data-rail]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ── init ──────────────────────────────────────────── */
  fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { setCount(c.item_count); })
    .catch(function () {});

  /* Shopify theme editor hooks */
  document.addEventListener('shopify:section:load', function () {
    $$('[data-reveal],[data-rail]').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
